<template>
  <div id="wrapper">
    <Nav :message="message" />
    <ReimbursementList />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import ReimbursementList from '@/components/finance/ReimbursementList.vue'

export default {
  name: 'reimbursement-list',
  props: ['message'],
  components: {
    Nav,
    ReimbursementList
  }
}
</script>